module.exports = __webpack_public_path__ + "img/ba.168f73fc.svg";